import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  ButtonGroup,
  Button,
  FormCheckbox,
  FormInput,
  Collapse,
  ListGroup,
  ListGroupItem,
  Form,
  FormSelect,
} from 'shards-react';

import { FaArrowUp, FaArrowDown } from 'react-icons/fa';
import { FiAlertCircle, FiEdit } from 'react-icons/fi';

import PageTitle from '../../components/common/PageTitle';
import LoadingContainer from '../../components/layout/LodingContainer';
import ErrorBox from '../../components/common/ErrorBox';
import SearchSelect from '../../components/common/SearchSelect';
import { InputWrapper } from '../common/styles';

import {
  getTimestampConfigsRequest,
  updateTimestampConfigRequest,
} from '../../store/modules/renotarizations/actions';
import { getAllInstitutionsRequest } from '../../store/modules/institution/actions';

import { scrollMore } from '../../utils/scrolls';

const DEFAULT_DEADLINE = 120;

export default function Renotarizations() {
  const dispatch = useDispatch();

  const institutions = useSelector((state) => state.institution.institutions);
  const { configs, loading, isSubmitting } = useSelector(
    (state) => state.renotarizations
  );

  const [selectedInstitution, setSelectedInstitution] = useState(null);
  const [isAllInstitutions, setIsAllInstitutions] = useState(true);
  const [statusFilter, setStatusFilter] = useState('');
  const [isAllStatuses, setIsAllStatuses] = useState(true);
  const [showFilter, setShowFilter] = useState(true);
  const [filterError, setFilterError] = useState(null);

  const [selectedConfig, setSelectedConfig] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isAutoRenotarization, setIsAutoRenotarization] = useState(false);
  const [deadline, setDeadine] = useState(DEFAULT_DEADLINE);

  /*eslint-disable */
  useEffect(() => {
    dispatch(getAllInstitutionsRequest());
  }, [dispatch]);
  /* eslint-enable */

  function getConfigs() {
    const query = {
      ...(!isAllInstitutions &&
        selectedInstitution && { client_id: selectedInstitution.client_id }),
    };
    dispatch(getTimestampConfigsRequest(query));
  }

  function handleInstitutionFilter(inst) {
    setSelectedInstitution(inst);
  }

  function handleFilterSubmit(e) {
    e.preventDefault();
    setFilterError(null);

    if (!isAllInstitutions && !selectedInstitution) {
      setFilterError('Selecione uma instituição');
      return;
    }

    getConfigs();
  }

  function handleSelectConfig(config) {
    const originalIndex = configs.findIndex(
      (c) => (c.id || c.client_id) === (config.id || config.client_id)
    );
    setSelectedIndex(originalIndex);
    setSelectedConfig(config);
    const enabled = config.renotorizationLimitInDays > -1;
    setIsAutoRenotarization(enabled);
    setDeadine(enabled ? config.renotorizationLimitInDays : DEFAULT_DEADLINE);
    setTimeout(() => scrollMore(400), 100);
  }

  function handleUpdateSubmit(e) {
    e.preventDefault();
    dispatch(
      updateTimestampConfigRequest(
        selectedConfig.id,
        {
          renotorizationLimitInDays: isAutoRenotarization
            ? Number(deadline)
            : -1,
        },
        selectedIndex,
        () => setSelectedConfig(null)
      )
    );
  }

  function getFilteredConfigs() {
    if (!configs) return [];
    if (isAllStatuses) return configs;
    if (statusFilter === 'enabled')
      return configs.filter((c) => c.renotorizationLimitInDays > -1);
    if (statusFilter === 'disabled')
      return configs.filter((c) => !(c.renotorizationLimitInDays > -1));
    return configs;
  }

  const filteredConfigs = getFilteredConfigs();

  return (
    <Container fluid className="main-content-container px-4">
      <Row noGutters className="page-header py-4">
        <PageTitle
          sm="4"
          title="Gerenciar Renotarizações"
          subtitle="Gestão de registros"
          className="text-sm-left"
        />
      </Row>

      <Row id="form-container">
        <Col>
          <Card className="mb-3" small>
            <CardHeader className="border-bottom">
              <Row>
                <Col sm="6">
                  <h6 className="m-0 font-weight-bold">Filtros</h6>
                </Col>
                <Col sm="6" className="text-right">
                  <Button
                    theme="light"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <span className="mr-2">
                      {showFilter ? <FaArrowUp /> : <FaArrowDown />}
                    </span>
                    {showFilter ? 'Esconder' : 'Mostrar'}
                  </Button>
                </Col>
              </Row>
            </CardHeader>
            <Collapse open={showFilter}>
              <ListGroup flush>
                <ListGroupItem className="p-3">
                  <Row>
                    <Col>
                      <Form onSubmit={handleFilterSubmit}>
                        <Row form>
                          <Col md="6" className="form-group">
                            <span className="text-dark font-weight-bold">
                              Instituição
                            </span>
                            <Row className="pt-2">
                              <Col md="8">
                                <SearchSelect
                                  placeholder="Pesquisa por nome, sigla ou client_id"
                                  onSelect={handleInstitutionFilter}
                                  value={selectedInstitution?.value}
                                  options={
                                    institutions &&
                                    institutions.map((i) => ({
                                      label: `${i.name} - ${i.initials}`,
                                      value: i._id,
                                      client_id: i.client_id,
                                    }))
                                  }
                                  styleContainer={{ marginTop: '0px' }}
                                  disabled={isAllInstitutions}
                                />
                              </Col>
                              <Col md="4" className="pt-2 pl-0">
                                <FormCheckbox
                                  checked={isAllInstitutions}
                                  onChange={() => {
                                    setIsAllInstitutions(!isAllInstitutions);
                                    if (!isAllInstitutions)
                                      setSelectedInstitution(null);
                                  }}
                                >
                                  <span className="text-dark">Ver todas</span>
                                </FormCheckbox>
                              </Col>
                            </Row>
                          </Col>
                          <Col md="4" className="form-group">
                            <span className="text-dark font-weight-bold">
                              Status
                            </span>
                            <Row className="pt-2">
                              <Col md="8">
                                <FormSelect
                                  value={statusFilter}
                                  onChange={(e) =>
                                    setStatusFilter(e.target.value)
                                  }
                                  disabled={isAllStatuses}
                                  required={!isAllStatuses}
                                >
                                  <option value="" disabled>
                                    Escolher...
                                  </option>
                                  <option value="enabled">Habilitada</option>
                                  <option value="disabled">Desabilitada</option>
                                </FormSelect>
                              </Col>
                              <Col md="4" className="pt-2 pl-0">
                                <FormCheckbox
                                  checked={isAllStatuses}
                                  onChange={() => {
                                    setIsAllStatuses(!isAllStatuses);
                                    if (!isAllStatuses) setStatusFilter('');
                                  }}
                                >
                                  <span className="text-dark">Ver todos</span>
                                </FormCheckbox>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <Row form>
                          <Col md="8">
                            <ErrorBox error={filterError} />
                          </Col>
                          <Col md="4" className="text-right">
                            <Button className="btn-primary ml-3">
                              Consultar
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </Col>
                  </Row>
                </ListGroupItem>
              </ListGroup>
            </Collapse>
          </Card>
        </Col>
      </Row>

      {loading && (
        <Row>
          <Col>
            <Card small className="mb-4">
              <CardBody className="p-0 pb-3 pl-3 pr-3 overflow-auto">
                <LoadingContainer loading={loading} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}

      {!loading && configs && (
        <Row>
          <Col>
            <Card small className="mb-4">
              <CardBody className="p-0 pb-3 pl-3 pr-3 overflow-auto">
                {filteredConfigs.length > 0 ? (
                  <table className="table mb-0">
                    <thead className="bg-light">
                      <tr>
                        <th scope="col" className="border-0">
                          #
                        </th>
                        <th scope="col" className="border-0">
                          Nome
                        </th>
                        <th scope="col" className="border-0">
                          Sigla
                        </th>
                        <th scope="col" className="border-0">
                          Prazo de renotarização
                        </th>
                        <th scope="col" className="border-0">
                          Status
                        </th>
                        <th scope="col" className="border-0">
                          Ações
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredConfigs.map((config, index) => {
                        const isEnabled = config.renotorizationLimitInDays > -1;
                        return (
                          <tr key={config.id || config.client_id}>
                            <td>{index + 1}</td>
                            <td>{config.institutionName}</td>
                            <td>{config.institutionInitials}</td>
                            <td>
                              {isEnabled
                                ? `${config.renotorizationLimitInDays} dias`
                                : '-'}
                            </td>
                            <td>{isEnabled ? 'Habilitada' : 'Desabilitada'}</td>
                            <td>
                              <ButtonGroup size="sm">
                                <Button
                                  theme="white"
                                  onClick={() => handleSelectConfig(config)}
                                >
                                  <span className="text-light">
                                    <FiEdit />
                                  </span>{' '}
                                  Ações
                                </Button>
                              </ButtonGroup>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                ) : (
                  <div className="col-sm-12 d-flex justify-content-center">
                    <h5 className="mt-3">
                      <FiAlertCircle className="mr-2" />
                      Não existem configurações para os filtros selecionados
                    </h5>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}

      {selectedConfig && (
        <Row id="details-container">
          <Col>
            <Card className="mb-3" small>
              <CardHeader className="border-bottom">
                <h6 className="m-0 font-weight-bold">
                  Informações sobre a renotarização
                </h6>
              </CardHeader>
              <ListGroup flush>
                <ListGroupItem className="p-3">
                  <Form onSubmit={handleUpdateSubmit}>
                    <Row form>
                      <Col md="6" className="form-group">
                        <InputWrapper>
                          <label htmlFor="det-nome">Nome da instituição</label>
                          <FormInput
                            id="det-nome"
                            value={selectedConfig.institutionName}
                            disabled
                          />
                          <span className="text-muted">
                            *Campo somente leitura.
                          </span>
                        </InputWrapper>
                      </Col>
                      <Col md="2" className="form-group">
                        <InputWrapper>
                          <label htmlFor="det-sigla">Sigla</label>
                          <FormInput
                            id="det-sigla"
                            value={selectedConfig.institutionInitials}
                            disabled
                          />
                          <span className="text-muted">
                            *Campo somente leitura.
                          </span>
                        </InputWrapper>
                      </Col>
                    </Row>
                    <Row form>
                      <Col md="6" className="form-group">
                        <span className="text-dark font-weight d-block mb-2">
                          Renotarização automática
                        </span>
                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for */}
                        <label
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '10px',
                            cursor: 'pointer',
                            userSelect: 'none',
                          }}
                        >
                          <input
                            type="checkbox"
                            style={{ display: 'none' }}
                            checked={isAutoRenotarization}
                            onChange={() => {
                              const next = !isAutoRenotarization;
                              setIsAutoRenotarization(next);
                              if (next) setDeadine(DEFAULT_DEADLINE);
                            }}
                          />
                          <span
                            style={{
                              width: '42px',
                              height: '22px',
                              background: isAutoRenotarization
                                ? '#007bff'
                                : '#ccc',
                              borderRadius: '12px',
                              position: 'relative',
                              transition: 'background .15s',
                              display: 'inline-block',
                              flexShrink: 0,
                            }}
                          >
                            <span
                              style={{
                                position: 'absolute',
                                top: '2px',
                                left: isAutoRenotarization ? '22px' : '2px',
                                width: '18px',
                                height: '18px',
                                background: '#fff',
                                borderRadius: '50%',
                                transition: 'left .18s',
                                boxShadow: '0 1px 3px rgba(0,0,0,.3)',
                              }}
                            />
                          </span>
                          <span className="text-dark">
                            {isAutoRenotarization
                              ? 'Habilitada'
                              : 'Desabilitada'}
                          </span>
                        </label>
                        <span
                          className="text-muted d-block mt-1"
                          style={{ fontSize: '11px', fontWeight: 'bold' }}
                        >
                          *Habilite para que o sistema renotarize os documentos
                          desta instituição automaticamente, conforme o prazo
                          configurado.
                        </span>
                      </Col>
                      <Col md="3" className="form-group">
                        <InputWrapper>
                          <label htmlFor="det-deadline">
                            Prazo de renotarização (dias)
                          </label>
                          <FormInput
                            id="det-deadline"
                            type="number"
                            value={isAutoRenotarization ? deadline : ''}
                            min={0}
                            onChange={(e) => setDeadine(e.target.value)}
                            disabled={!isAutoRenotarization}
                            required={isAutoRenotarization}
                          />
                          <span className="text-muted">
                            *Quantidade de dias antes da expiração do carimbo de
                            tempo em que a renotarização será realizada
                            automaticamente.
                          </span>
                        </InputWrapper>
                      </Col>
                    </Row>
                    <Row form>
                      <Col className="text-right">
                        <Button
                          theme="secondary"
                          className="mr-2"
                          type="button"
                          onClick={() => setSelectedConfig(null)}
                        >
                          Cancelar
                        </Button>
                        <Button theme="primary" disabled={isSubmitting}>
                          {isSubmitting ? 'Salvando...' : 'Atualizar'}
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </ListGroupItem>
              </ListGroup>
            </Card>
          </Col>
        </Row>
      )}
    </Container>
  );
}
